module.exports = __webpack_public_path__ + "img/15.853f9f58.jpg";